import React, { useState, useEffect } from "react";
import EN from "../../assets/images/langEn.png";
import TH from "../../assets/images/langTh.png";
import "../../assets/styles/components/footer.scss";
import { Button } from "antd";
import { i18n } from '../../i18n/i18n';
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { namespaces, languages } from '../../i18n/i18n.constants';


interface Props {
  noHeader?: boolean;
  firstPage?: boolean;
  btnBack?: boolean;
  onClick?: () => void;
  title?: string;
  children?: object;
}


interface UserItem {
  email: string;
  gender: string;
  name: {
    first: string;
    last: string;
    title: string;
  };
  nat: string;
  picture: {
    large: string;
    medium: string;
    thumbnail: string;
  };
}

const ContainerHeight = 400;
const FooterBar: React.FC<Props> = ({
  noHeader = false,
  btnBack = false,
  title = "",
  children,
  onClick
}) => {
  const { search } = useLocation();
  const query: any = queryString.parse(search);
  const currentURL = window.location.href
  if (
    query?.from !== undefined || query?.reques !== undefined || query?.customerid !== undefined
  ) {
    localStorage.setItem("param_from", query?.from);
    localStorage.setItem("param_reques", query?.reques);
    localStorage.setItem("param_customer", query?.customerid);
    localStorage.setItem("param_token", query?.token);

    if (query?.identifier !== undefined || query?.ndid_phase !== undefined){
      localStorage.setItem("param_identifier", query?.identifier);
      localStorage.setItem("param_ndid_phase", query?.ndid_phase);
    }

  }
  const paramFrom = localStorage.getItem("param_from");
  const paramReques = localStorage.getItem("param_reques");
  const param_customer = localStorage.getItem("param_customer");
  const param_token = localStorage.getItem("param_token");
  const history = useHistory();

  return (
    <div className="footer-bar">
      {paramFrom === "daolinv" && paramReques === "reviewsuitandkyc" ? 
        (<>
          <span>บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด เลขที่ 87/2 อาคารซีอาร์ซีทาวเวอร์ ชั้น 52 ออลซีซั่นส์เพลส ถนนวิทยุแขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330 (สำนักงานใหญ่)</span>
          <p>ติดต่อฝ่ายบริการลูกค้าโทร : 0 2351 1800 กด 2 อีเมล : customercare_investment@daol.co.th</p>
          <span>©2023 บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด สงวนลิขสิทธิ์</span>
        </>
        )
        : ""
      }
    </div >
  );
};
export default FooterBar;
